import { Injectable } from '@angular/core';
import { SharedService } from "./shared.service";
import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment'
import { SearchCustomerParam, PaymentAgingParam } from '../Models/searchCustomer';
import { SearchProductparam } from '../Models/search-product';
import { TaxApiParam } from '../Models/tax';
import { SpraRequestDetail,SPRASerivceRequestData,SpraApprovalDetail, SpraValidation,SpraStatusReport, SpraSearch } from '../Models/ops';


@Injectable()
export class TransactionService {

  constructor(private http: HttpClient, private _sharedService: SharedService) { }

  public GetAllOffices(OfficeId?: number) {
    let Data = {
      OfficeId: OfficeId
    }
    return this._sharedService.Get("Master/GetAllOffices", Data);
  }


  public GetDealersFroSpraSeacrch(searchCustomerParam: SearchCustomerParam) {
    return this._sharedService.Post("Master/GetDealersFroSpraSeacrch", searchCustomerParam);
  }
 
  public GetPaymentAging(paymentAgingParam: PaymentAgingParam) {
    return this._sharedService.Post("Transaction/GetPaymentAging", paymentAgingParam);
  }

  public GetExcelDocument(searchCustomerParam: SearchCustomerParam) {
    return this._sharedService.ExcelPost("Master/GetExcelDocument", searchCustomerParam);
  }
 
  public ImportExcelDocument(formdata: any) {
    return this._sharedService.ImportExcelPost("Master/ImportExcelDocument", formdata);
  }

  public GetProductPriceExcelDocument(searchProductparam: SearchProductparam) {
    return this._sharedService.ExcelPost("Master/GetProductPriceExcelDocument", searchProductparam);
  }

  public ImportProductPriceExcelDocument(formdata: any) {
    return this._sharedService.ImportExcelPost("Master/ImportProductPriceExcelDocument", formdata);
  }

  public GetCsaRateExcelDocument(searchProductparam: SearchProductparam) {
    return this._sharedService.ExcelPost("Master/GetCsaRateExcelDocument", searchProductparam);
  }

  public ImportCSARateExcelDocument(formdata: any) {
    return this._sharedService.ImportExcelPost("Master/ImportCSARateExcelDocument", formdata);
  }

  public GetOpsTax(taxApiParam: TaxApiParam) {
    return this._sharedService.Post("Tax/GetTaxValues", taxApiParam);
  }

  public InsertSpraRequest(spraRequestDetail: SpraRequestDetail) {
    return this._sharedService.Post("Transaction/InsertSpraRequest", spraRequestDetail);
  }

  //Added by swati
  public GetAllSPRARequestList(Id?: number, IsCeha?:boolean) {
    let Data = {
      SPRARequestID: Id,
      IsCeha : IsCeha //Added by rahul yadav on 07/06/2021 
    }
    return this._sharedService.Get("Transaction/GetAllSPRARequest", Data);

  }
  

  public GetSpraValidationList(EmployeeId?:number,IsCeha?:boolean){
    let Data = {
      EmployeeId: EmployeeId,
      IsCeha:IsCeha
    }
    return this._sharedService.Get("Transaction/GetSpraValidationList",Data);
  }



  public GetValidationListForAdminSales(IsCeha?:boolean){
    let Data = {
      IsCeha:IsCeha
    }
    return this._sharedService.Get("Transaction/GetSpraValidationListForAdminSales",Data);
  }

  public GetReviewListForAdminSales(IsCeha?:boolean){
    let Data = {
      IsCeha:IsCeha
    }
    return this._sharedService.Get("Transaction/GetSpraReviewListForAdminSales",Data);
  }

   //Added by swati on 01/02/2021
   public GetAllSPRARequestById(Id: number,IsForPriceRef:boolean = false) {
    let Data = {
      SPRARequestID: Id,
      IsForPriceRef:IsForPriceRef
    } 
    return this._sharedService.Get("Transaction/GetSPRARequestById", Data);

  }
 

  //added by swati on 08/03/2021  
  public UpdateSPRAServiceData(spraReqServiceDetail: SPRASerivceRequestData) {
    return this._sharedService.Post("Transaction/UpdateSPRAServiceDetailById", spraReqServiceDetail);
  }

  public UpdateSPRAData(spraRequestDetail: SpraRequestDetail) {
    return this._sharedService.Post("Transaction/UpdateSpraRequest", spraRequestDetail);
  }

  public InsertSPRAApproval(spraAppDetail: SpraApprovalDetail) {
    return this._sharedService.Post("Transaction/InsertSpraApproval", spraAppDetail);
  }

  public ValidationSPRA(spraValidation: SpraValidation) {
    return this._sharedService.Post("Transaction/ValidationSPRA", spraValidation);
  }

  public GetSpraListByCompanyId(CompanyId:number,IsRental:Boolean) {
    let Data = {CompanyId: CompanyId,IsRental}   
    return this._sharedService.Get("Transaction/GetSpraListByCompanyId", Data);
  }

  public GetSpraEnquireyDetailById(EnquiryId:number) {
    let Data = {EnquiryId: EnquiryId}   
    return this._sharedService.Get("Transaction/GetSpraEnquireyDetailById", Data);
  }
//added by rahul yadav on 15/7/2022 for consignee distanceid
  public GetConsigneeDistanceId(Consignee:any) {
    let Data = {Consignee: Consignee}   
    return this._sharedService.Get("Transaction/GetConsigneeDistanceId", Data);
  }

  public UpdateSPRADocumentById(spraId :number,documents:string) {
    let Data = {spraId: spraId,documents:documents}   
    return this._sharedService.Get("Transaction/UpdateSPRADocumentById", Data);
  }

  

        /// CREATED BY: Swati Gupta
        /// CREATED DATE : 10/05/2021
        /// Purpose : Fetch Consignee detail on the basis of spra id 
  public GetSPRAConsigneeDetail(SPRAId:number) {
    let Data = {SPRAId: SPRAId}   
    return this._sharedService.Get("Transaction/GetSPRAConsigneeDetail", Data);
  }

  public GetFiscalForSPRA() {
    return this._sharedService.Get("Transaction/GetFiscalForSPRA");
  }


  public DownloadConsumableTarget(FiscalNo:number,ProductGroupId:number) {
    let Data = {FiscalNo:FiscalNo,ProductGroupId:ProductGroupId};
    return this._sharedService.ImportExcelPost("Transaction/DownloadConsumableTarget",Data);
  }
  public UploadConsumableTarget(formdata: any) {
    return this._sharedService.ImportExcelPost("Transaction/UploadConsumableTarget", formdata);
  }  

  
  public GetDealerConsumableBillingDetail(PartnerId:number) {
    let Data = {PartnerId:PartnerId};
    return this._sharedService.Get("Transaction/GetDealerConsumableBillingDetail",Data);
  }
  

  public GetSPRAStatusReportData(spraStatusReport:SpraStatusReport) {
    // let Data = {spraStatusReport:spraStatusReport};
    return this._sharedService.ImportExcelPost("Transaction/GetSPRAStatusReportData",spraStatusReport);
  }

  public GetSPRAStatusReportView(spraStatusReport:SpraStatusReport) {
    // let Data = {spraStatusReport:spraStatusReport};
    return this._sharedService.Post("Transaction/GetSPRAStatusReportView",spraStatusReport);
  }
  
  public GetSpraDetailForValidation(SpraId:number,EmployeeId:number) {
    let Data = {SpraId:SpraId,EmployeeId:EmployeeId};
    return this._sharedService.Get("Transaction/GetSpraDetailForValidation",Data);
  }
  
  public ReviewSPRA(spraValidation: SpraValidation) {
    return this._sharedService.Post("Transaction/ReviewSPRA", spraValidation);
  }
  public InsertSpraReviewRequest(spraValidation: SpraValidation) {
    return this._sharedService.Post("Transaction/InsertSpraReviewRequest", spraValidation);
  }
  public GetSpraApprovedReviewListForAdminSales(spraSearch:SpraSearch){
    // debugger
    return this._sharedService.Post("Transaction/GetSpraApprovedReviewListForAdminSales",spraSearch);
  }

  public CheckOpsForSPRA(SPRAId :Number){
    let Data = {
      SPRAId:SPRAId
    }
    return this._sharedService.Get("Transaction/CheckOpsForSPRA",Data);
  }
}
